'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrganisationUnit = undefined;

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrganisationUnit = exports.OrganisationUnit = undefined;

exports.OrganisationUnit = OrganisationUnit = function OrganisationUnit(refs, config) {
    var t = this;

    t.id = config.id;
    t.refs = refs;
    t.i18n = refs.i18nManager.get();

    // dynamic
    t.ancestors = [];
    t.level = null;
};

OrganisationUnit.prototype.getLevel = function () {
    return this.level;
};

OrganisationUnit.prototype.setLevel = function (level) {
    this.level = level;
};

OrganisationUnit.prototype.getAncestors = function () {
    return this.ancestors;
};

OrganisationUnit.prototype.setAncestors = function (ancestors) {
    this.ancestors = (0, _arrayFrom2.default)(ancestors);
};

OrganisationUnit.prototype.getInstanceManager = function () {
    return this.refs.instanceManager;
};

OrganisationUnit.prototype.getAppManager = function () {
    return this.refs.appManager;
};

OrganisationUnit.prototype.getUpperLevels = function () {
    return this.getAncestors();
};

// dep 1

OrganisationUnit.prototype.getAncestorsRequest = function (shouldRun) {
    var Request = this.refs.api.Request;


    var request = new Request(refs, {
        baseUrl: this.getAppManager().getApiPath() + '/organisationUnits/' + this.id + '.json',
        type: 'json',
        params: ['fields=id,level,ancestors[id,level,displayName~rename(name)]', 'paging=false']
    });

    return shouldRun ? request.run() : request;
};

OrganisationUnit.prototype.getOrganisationUnitLevels = function () {
    return this.getAppManager().organisationUnitLevels;
};

OrganisationUnit.prototype.getResponse = function () {
    return this.getInstanceManager().getStateCurrent().getResponse();
};

OrganisationUnit.prototype.getRootAncestor = function () {
    var sorted = this.getAncestors().slice().sort(function (a, b) {
        return a.level > b.level;
    });

    return sorted.length ? sorted[0] : this;
};

OrganisationUnit.prototype.getParent = function () {
    var ancestors = this.getAncestors().slice().sort(function (a, b) {
        return a.level > b.level;
    });

    return ancestors.length ? ancestors[ancestors.length - 1] : null;
};

// dep 2

OrganisationUnit.prototype.getHierarchyName = function () {
    var _this = this;

    return this.getOrganisationUnitLevels().find(function (ou) {
        return ou.level === _this.getLevel();
    }).name;
};

OrganisationUnit.prototype.isRoot = function () {
    var ancestor = this.getRootAncestor();

    return ancestor ? this.getLevel() === ancestor.level : false;
};

OrganisationUnit.prototype.getName = function () {
    return this.getResponse().getNameById(this.id);
};

// dep 3

OrganisationUnit.prototype.getSublevels = function () {
    var _this2 = this;

    var level = this.getLevel();

    var sublevels = this.getOrganisationUnitLevels().filter(function (ou) {
        return ou.level > level;
    });

    sublevels = sublevels.map(function (ou) {
        return {
            id: _this2.id,
            name: ou.name.toLowerCase(),
            level: ou.level
        };
    });

    return sublevels;
};

// dep 4

OrganisationUnit.prototype.getContextMenuItemsConfig = function () {
    var _this3 = this;

    // fun goes here
    var items = [];

    var sublevels = this.getSublevels();
    var upperLevels = this.getUpperLevels();

    // generate upper levels
    if (upperLevels.length > 0) {
        items.push({
            isSubtitle: true,
            style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
            html: this.i18n.drill_up
        });

        upperLevels.forEach(function (ou) {
            items.push({
                items: [{ id: ou.id }],
                text: 'Show <span class="name">' + ou.name + '</span>',
                iconCls: 'ns-menu-item-float'
            });
        });
    }

    // generate menu item for current level
    items.push({
        isSubtitle: true,
        style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
        html: this.getHierarchyName()
    });

    items.push({
        items: [{ id: this.id }],
        text: 'Show only <span class="name">' + this.getName() + '</span>',
        iconCls: 'ns-menu-item-float'
    });

    if (this.getParent()) {
        items.push({
            items: [{ id: this.getParent().id + ';LEVEL-' + this.getLevel() }],
            text: 'Show all <span class="name">' + this.getHierarchyName() + ' units in ' + this.getParent().name + '</span>',
            iconCls: 'ns-menu-item-float'
        });
    }

    // generate menu items for sublevels
    if (sublevels.length > 0) {
        (function () {
            var root = _this3.getRootAncestor();

            items.push({
                isSubtitle: true,
                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
                html: _this3.i18n.drill_down
            });

            sublevels.forEach(function (ou) {
                items.push({
                    items: [{ id: ou.id + ';' + 'LEVEL-' + ou.level }],
                    text: 'Show all <span class="name">' + ou.name.toLowerCase() + ' units in ' + _this3.getName() + '</span>',
                    iconCls: 'ns-menu-item-float'
                });
            });

            sublevels.forEach(function (ou) {
                if (root.level !== _this3.getLevel()) {
                    items.push({
                        items: [{ id: root.id + ';' + 'LEVEL-' + ou.level }],
                        text: 'Show all <span class="name">' + ou.name + ' units</span>',
                        iconCls: 'ns-menu-item-float'
                    });
                }
            });
        })();
    }

    return items;
};
//# sourceMappingURL=OrganisationUnit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/OrganisationUnit.js
 ** module id = 112
 ** module chunks = 0 1
 **/